var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35355 8.35355L3.35355 10.3536C3.15829 10.5488 2.84171 10.5488 2.64645 10.3536L0.646447 8.35355C0.451184 8.15829 0.451184 7.84171 0.646447 7.64645C0.841709 7.45118 1.15829 7.45118 1.35355 7.64645L2.5 8.79289V1C2.5 0.723858 2.72386 0.5 3 0.5C3.27614 0.5 3.5 0.723858 3.5 1V8.79289L4.64645 7.64645C4.84171 7.45118 5.15829 7.45118 5.35355 7.64645C5.54882 7.84171 5.54882 8.15829 5.35355 8.35355Z",
    fill: "#9E0A05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.171947a2eea0555ff066ab80e1c95033.svg";
export { ForwardRef as ReactComponent };